// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2WaOV","title":"Header_title__1I8Nm","left":"Header_left__1LKYo","clinicName":"Header_clinicName__2jx86"};